import { Link } from 'react-router-dom';
import { useReferences } from '../hooks/useDiscovery';

export function CitiesIndex() {
  const { cities, loading } = useReferences();

  if (loading) {
    return (
      <div className="min-h-screen">
        <header className="bg-white border-b border-gray-200">
          <div className="container py-6">
            <div className="skeleton h-8 w-48" />
          </div>
        </header>
        <main className="container py-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
              <div key={i} className="card p-6">
                <div className="skeleton h-8 w-3/4 mb-2" />
                <div className="skeleton h-4 w-1/2" />
              </div>
            ))}
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <header className="bg-white border-b border-gray-200">
        <div className="container py-6">
          <Link to="/" className="text-sm text-gray-500 hover:text-gray-900 mb-4 inline-block">
            ← Volver a explorar
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Explorar por ciudad</h1>
          <p className="mt-2 text-gray-500">
            Encuentra recomendaciones en tu ciudad
          </p>
        </div>
      </header>

      <main className="container py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {cities.map((city) => (
            <Link
              key={city.id}
              to={`/cities/${city.id}`}
              className="card p-6 hover:shadow-lg transition-shadow group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-900 group-hover:text-primary transition-colors">
                {city.name}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                {city.recommendationCount} recomendación{city.recommendationCount !== 1 ? 'es' : ''}
              </p>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}